import React, {useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeUserSession } from '../../helpers/Helper';

const Login = (props) => {
    const navigate = useNavigate();
    useEffect(() => {
        removeUserSession();
        navigate("/");
    }, [navigate])

    return (
        <>
           
        </>
    );
}
export default Login;